const getX = (playerX: number, mapW: number) => 0.5 * mapW - playerX;
const getY = (playerY: number, mapH: number) => 0.5 * mapH - playerY;

export class GameMap {
  mapW: number;
  mapH: number;
  private playerX: number;
  private playerY: number;

  constructor(
    private map: HTMLDivElement,
    playerX: number,
    playerY: number,
  ) {
    this.mapW = this.map.clientWidth;
    this.mapH = this.map.clientHeight;
    this.playerX = playerX;
    this.playerY = playerY;
    // Defer initial pan; will update after first local player update

    this.map.addEventListener("resize", () => {
      this.mapW = this.map.clientWidth;
      this.mapH = this.map.clientHeight;
      this.updatePan(this.playerX, this.playerY);
    });
  }

  updatePan(playerX: number, playerY: number) {
    this.playerX = playerX;
    this.playerY = playerY;
    const nextTransform = `translate3d(${getX(this.playerX, this.mapW)}px, ${getY(this.playerY, this.mapH)}px, 0)`;
    this.map.style.transform = nextTransform;
    console.log("updated map pan", nextTransform);
  }
}
